module.exports = __webpack_public_path__ + "img/icon_my_setup_black.0520a1f9.png";